<template>
  <div>
    <header>
      <div class="mobile-fix-option"></div>
      <div class="top-header">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="header-contact">
                <ul>
                  <li>欢迎进入 Zerofast 在线商城</li>
                </ul>
              </div>
            </div>
            <div class="col-lg-6 text-end">
              <ul class="header-dropdown">
                <li class="onhover-dropdown mobile-account" v-if="user.user_id === ''" @click="checkAuth()">
                  <i class="fa fa-user" aria-hidden="true"></i> 我的账号
                  <ul class="onhover-show-div" v-if="!isMobile">
                    <li @click="checkAuth()">
                      <a>登录</a>
                    </li>
                  </ul>
                </li>
                <li class="onhover-dropdown mobile-account" v-else @click="goMyPage()">
                  <a-avatar :src="user.avatar"/> {{ user.nickname }}
                  <ul class="onhover-show-div" v-if="!isMobile">
                    <li @click="goMyPage">
                      <a>我的页面</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="main-menu">
              <div class="menu-left">
                <div class="navbar">
<!--                  <a href="javascript:void(0)" onclick="openNav()">-->
<!--                    <div class="bar-style">-->
<!--                      <i class="fa fa-bars sidebar-bar" aria-hidden="true"></i>-->
<!--                    </div>-->
<!--                  </a>-->
                  <div id="mySidenav" class="sidenav">
                    <a href="javascript:void(0)" class="sidebar-overlay" onclick="closeNav()"></a>
                    <nav>
                      <div onclick="closeNav()">
                        <div class="sidebar-back text-start">
                          <i class="fa fa-angle-left pe-2" aria-hidden="true"></i> Back
                        </div>
                      </div>
                      <!-- Vertical Menu -->
                      <ul id="sub-menu" class="sm pixelstrap sm-vertical ">
                      </ul>
                    </nav>
                  </div>
                </div>
                <div class="brand-logo">
                  <a href="index.html">
                    <img src="https://www.zerofast.net/assets/images/logo-color.png" style="max-width: 200px;" class="img-fluid blur-up lazyload" alt="">
                  </a>
                </div>
              </div>
              <div class="menu-right pull-right">
                <div>
<!--                  <nav id="main-nav">-->
<!--                    <div class="toggle-nav">-->
<!--                      <i class="fa fa-bars sidebar-bar"></i>-->
<!--                    </div>-->
<!--                    <ul id="main-menu" class="sm pixelstrap sm-horizontal">-->
<!--                      <li>-->
<!--                        <div class="mobile-back text-end">Back <i class="fa fa-angle-right ps-2" aria-hidden="true"></i>-->
<!--                        </div>-->
<!--                      </li>-->
<!--                      <li>-->
<!--                        <a href="index.html">Home<div class="lable-nav">new</div></a>-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                  </nav>-->
                </div>
                <div>
                  <div class="icon-nav">
                    <ul>
                      <li class="onhover-div mobile-cart">
                        <div @click="goCart" style="margin-right: 20px;">
                          <a-badge :count="cart.length">
                            <img src="../assets/images/icon/cart.png" class="img-fluid blur-up lazyload" alt="">
                            <i class="ti-shopping-cart"></i>
                          </a-badge>
                        </div>
                        <ul class="show-div shopping-cart" v-if="!isMobile">
                          <li v-for="(goods, i) in cart" :key="goods.plan.plan_id">
                            <div class="media">
                              <a href="#">
                                <img class="me-3" :src="goods.pic" alt="Zerofast XR10">
                              </a>
                              <div class="media-body">
                                <a href="#">
                                  <h5>{{ goods.plan.name }}（{{ goods.service.name }}）</h5>
                                </a>
                                <h6 style="color: #aaa">
                                  <span>￥{{ goods.plan.price | number('0,0.00') }} + ￥{{ goods.service.price | number('0,0.00') }}</span>
                                  <a-button size="small" style="position: absolute; right: 0px;" @click="removeCart(i)">x</a-button>
                                </h6>
                                <span style="font-size: 14px;">x {{ goods.qty }}</span>
                              </div>
                            </div>
<!--                            <div class="close-circle">-->
<!--                              <a @click="removeCart(i)">-->
<!--                                <i class="fa fa-times" aria-hidden="true"></i>-->
<!--                              </a>-->
<!--                            </div>-->
                          </li>
                          <li>
                            <div class="total">
                              <h5>合计 : <span>￥{{ total | number('0,0')}}</span>
                              </h5>
                            </div>
                          </li>
                          <li>
                            <div class="buttons">
                              <a style="cursor: pointer;" @click="goCart" class="checkout">结算</a>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <a-modal title="登录" v-model="showWechat" :footer="null" style="display: flex; justify-content: center;">
      <LoginSection :wechat="wechat"></LoginSection>
    </a-modal>
  </div>
</template>

<script>
import { setCart, getToken } from '@/libs/util'
import { getUserInfo } from '@/api/user'
import { User } from '@/api/model'
import config from '@/config'
import { baseMixin } from '@/libs/app-mixin'
import mobile from 'is-mobile'
import LoginSection from '@/components/blocks/LoginSection'

export default {
  name: 'Header',
  mixins: [baseMixin],
  components: {
    LoginSection
  },
  props: {
    cart: {
      type: Array
    },
    userInfo: {
      type: Object
    },
    showWechat: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isMobile: mobile(),
      total: 0,
      cart_qty: 0,
      wechat: {
        url: ''
      },
      token: '',
      user: User()
    }
  },
  methods: {
    getCartTotal () {
      this.total = 0
      this.cart_qty = 0
      this.cart.forEach(v => {
        this.total += (v.plan.price + v.service.price) * v.qty
        this.cart_qty += v.qty
      })
    },
    removeCart (i) {
      this.cart.splice(i, 1)
    },
    goCart () {
      if (!this.checkAuth()) {
        return false
      }
      if (this.cart.length === 0) {
        this.$message.info('购物车空空如也~')
        return false
      }
      location.href = '/#/cart'
      window.scrollTo(0, 0)
    },
    checkAuth () {
      this.token = getToken()
      if (this.token === false) {
        if (this.checkEnv() === 'wechat') {
          location.href = this.wechat.url
        } else {
          this.showWechat = true
        }
        return false
      }
      return true
    },
    goMyPage () {
      location.href = '/#/my/dashboard'
      window.scrollTo(0, 0)
    },
    getWechatUrl () {
      const token = getToken()
      if (token === false) {
        const redirect = encodeURI(config.ssoUrl)
        if (this.checkEnv() === 'web') {
          const appid = 'wx56610615281b2c87'
          const state = 'member'
          this.wechat.url = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect}&response_type=code&scope=snsapi_login&state=${state}#wechat_redirect`
        } else if (this.checkEnv() === 'wechat') {
          const appid = 'wx3cf92c62c10802be'
          const state = 'h5'
          this.wechat.url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`
        }
        return false
      }
      this.getUserInfo()
    },
    getUserInfo () {
      const token = getToken()
      if (token === false) {
        return false
      }
      if (this.$parent.isLoadUser) {
        getUserInfo().then(res => {
          if (res.code !== 200) {
            this.$message.info(res.msg)
            return false
          }
          this.user = res.result
        })
      }
    }
  },
  watch: {
    cart: {
      handler (newValue, oldValue) {
        this.getCartTotal()
        setCart(this.cart)
      },
      deep: true
    },
    token: {
      handler (newValue, oldValue) {
        this.getUserInfo()
      }
    },
    user: {
      handler (newValue, oldValue) {
        this.$parent.user = this.user
      }
    },
    userInfo: {
      handler (newValue, oldValue) {
        if (this.userInfo) {
          this.user = this.userInfo
        }
        this.$parent.user = this.user
      }
    }
  },
  mounted () {
    this.token = getToken()
    this.getWechatUrl()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue